import { Component, Input, signal } from '@angular/core';
import { MatCardImage, MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-card-image',
  imports: [MatCardModule],
  templateUrl: './card-image.component.html',
  styleUrl: './card-image.component.scss',
})
export class CardImageComponent implements MatCardImage {
  @Input()
  alt = '';

  @Input({ required: true })
  src = '';

  isLoaded = signal(false);
  hasError = signal(false);
}
